import fetch from "../fetch";
import pickBy from "lodash/pickBy";

export default ({ params = {} } = {}) =>
  fetch({ path: "/hy/funds", params: pickBy(params) });
